module.exports = __webpack_public_path__ + "img/i_tooltip.beee1eb5.svg";